import Api from "../../../lib/api";
import { getElementTopPosition } from "../../../lib";
import DOMHelper from "../../../lib/dom-helper";
import CompaniesSlider from "../../../components/companies-slider";
import ReviewsSlider from "../../../components/reviews-slider";
import Accordion from "../../../components/accordion";
import FormController from "./form-controller";
import initQuiz from './quiz';

import initCoachesSection from "../../../components/coaches-section";
import ModalForm from "../../../components/base/forms/modal-form";
import PortfolioSection from "../../../components/portfolio-section";
import Dropdown from "../../../components/base/dropdown";
import WidgetQuarantineVideo from "./widget-quarantine-video";
import ProgrammeCertificate from "./programme-certificate";
import VideoModal from "../../../components/base/video-modal";
import {AnalyticsService} from "../../../services/analytics-service";
import IntroductionSection from "./introduction-section";
import AnchorNav from "../../../global/header/anchor-nav";
import CheckoutModal from "./checkout/checkout-modal";
import WidgetLeadMagnet from "./widget-lead-magnet";
import EnvHelper from "../../../lib/env-helper";

export default class PageModule {
	constructor() {
		this.init();
	}

	init() {
		this.initAnchorNav();
		this.initIntroductionSection();
		this.initFormController();
		this.sendAnalytics();
		this.scrollToFaq();
		this.initWidgetQuarantineVideo();
		this.initHeroDropdown();
		// this.initCourseStats(); TODO: Needs refactoring, duplicated content in the IntroductionSection
		this.initQuiz();
		this.initCoachesSection();
		this.initProgrammeSection();
		this.initCompaniesSlider();
		this.initReviewsSlider();
		this.initFaqAccordion();
		this.initVideoAboutSchool();
		this.initVideoModal();
		this.initPortfolioSection();
		this.initPriceBlock();
		this.initLeadMagnet();
		this.initCheckoutModal();
	}

	initAnchorNav() {
		new AnchorNav();
	}

	initIntroductionSection() {
		new IntroductionSection();
	}

	initFormController() {
		const formController = new FormController();
	}

	sendAnalytics() {
		if (craft.page.coursesStatsConfig &&
			craft.page.coursesStatsConfig.entryId
		) {
			/* FB Analytics data for backend */
			Api.sendFbEvent('ViewContent', {
				entryId: craft.page.coursesStatsConfig.entryId
			});
		} else {
			console.error('Api/fbq: entryId is not defined');
		}

		document.querySelectorAll('.lms-buy-link').forEach(($trigger) => {
			$trigger.href = Api.updateUrlWithUtmTagQueryParams($trigger.href);

			$trigger.addEventListener('click', (e) => {
				e.preventDefault();
				AnalyticsService.sendEvent('to_lms_purchase');
				location.href = $trigger.href;
			});
		});

		const $sprintMagnetLMSLink = document.querySelector('.sprint-magnet-lms');

		if ($sprintMagnetLMSLink) {
			$sprintMagnetLMSLink.href = Api.updateUrlWithUtmTagQueryParams($sprintMagnetLMSLink.href);
		}
	}

	scrollToFaq() {
		if (location.hash === '#faq') {
			const $anchor = document.getElementById('faq');
			const anchorPosition = getElementTopPosition($anchor) - 50;
			setTimeout(() => {
				window.scrollTo(0, anchorPosition);
			}, 4);
		}

		window.addEventListener('hashchange', () => {
			if (location.hash === '#faq') {
				const $anchor = document.getElementById('faq');
				const anchorPosition = getElementTopPosition($anchor) - 50;
				setTimeout(() => {
					window.scrollTo(0, anchorPosition);
				}, 4);
			}
		});
	}

	initWidgetQuarantineVideo() {
		const $widget = document.getElementById('widgetQuarantineVideo');

		if ($widget) {
			this.quarantineVideoWidget = new WidgetQuarantineVideo({
				$root: $widget
			});
		}
	}

	initHeroDropdown() {
		const $menu = document.querySelector('[data-dropdown-menu="heroCity"]');
		const $trigger = document.querySelector('[data-dropdown-trigger="heroCity"]');

		if (!$menu || !$trigger) {
			return;
		}

		const dropdown = new Dropdown($menu, $trigger);
	}

	// initCourseStats() {
	// 	const courseStats = new CourseStats();
	// }

	initQuiz() {
		if (document.getElementById('modal-quiz-trigger')) {
			try {
				initQuiz();
			} catch (err) {
				console.log('Quiz:', err);
			}
		}
	}

	initCoachesSection() {
		if (!document.getElementById('coachesSection')) {
			return;
		}

		initCoachesSection();

		const $mentorTrigger = document.getElementById('mentor-trigger');

		if ($mentorTrigger) {
			try	{
				this.consultationForm = new ModalForm({
					formId: 'mentor',
					uri: '/1.0/coaches/mentor-registration',
					$modalTriggers: [$mentorTrigger]
				});
			} catch (err) {
				console.error('Mentor Form:', err);
			}
		}
	}

	initPortfolioSection() {
		if (document.getElementById('md-portfolio-section')) {
			const portfolioSection = new PortfolioSection();
		}
	}

	initProgrammeSection() {
		const programmeCertificate = new ProgrammeCertificate();
		const accordion = new Accordion('accordion-programme');

		/* Copy programme section anchor link to clipboard,
		 * by clicking on the programme section header */
		const $programmeHeader = document.getElementById('programmeHeader');
		if ($programmeHeader) {
			const anchorLink = window.location.origin + window.location.pathname + '#program';
			$programmeHeader.addEventListener('click', () => {
				DOMHelper.copyTextToClipboard(anchorLink);
			});
		}

		/* Scroll to programme-section if #programme hash is present */
		if (window.location.hash && (/program/g).test(window.location.hash)) {
			const $programmeSection = document.querySelector('.section.-programme');
			if ($programmeSection) {
				setTimeout(() => {
					const topPos = DOMHelper.getElementTopPosition($programmeSection);
					window.scrollTo(0, topPos + 50);
				}, 50);
			}
		}
	}

	initCompaniesSlider() {
		const companiesSlider = new CompaniesSlider();
	}

	initReviewsSlider() {
		const reviewsSlider = new ReviewsSlider();
	}

	initFaqAccordion() {
		if (!document.getElementById('accordion-faq')) {
			return;
		}

		const accordion = new Accordion('accordion-faq');

		/* Init faq question links */
		const $questionLinks = document.querySelectorAll('.faq-question-link');

		if (!$questionLinks.length) {
			return;
		}

		/* Add click handlers for all question links */
		$questionLinks.forEach((questionLink) => {
			questionLink.addEventListener('click', () => {
				const $faqQuestionCard = document.querySelector(`[data-faq-question-id="${questionLink.dataset.for}"]`);

				/* If the card has been found, scroll to the card position and open it */
				if ($faqQuestionCard) {
					window.scrollTo(0, DOMHelper.getElementTopPosition($faqQuestionCard) - DOMHelper.pinnedHeaderHeight);
					accordion.closeAllAndOpen($faqQuestionCard);
				}
			});
		});
	}

	initVideoAboutSchool() {
		if (!document.querySelectorAll(`[data-modal-trigger="about-school"]`).length) {
			return;
		}

		const videoModal = new VideoModal({
			id: 'about-school'
		});
	}

	initVideoModal() {
		if (!document.getElementById('videoPresentationSection')) return;

		const videoModal = new VideoModal({
			id: 'video-presentation'
		});
	}

	initPriceBlock() {
		const $buyCourseFormTrigger = document.getElementById('buyCourseFormTrigger');

		if ($buyCourseFormTrigger == null) {
			return;
		}

		$buyCourseFormTrigger.addEventListener('click', () => {
			AnalyticsService.sendEvent('buy_course_button');
		});
	}

	initLeadMagnet() {
		new WidgetLeadMagnet({
			showDelay: 30000,
			data: {
				city: EnvHelper.env.cityId,
				course: EnvHelper.page.courseDirectoryId
			},
			relatedSprintSlug: EnvHelper.page.relatedSprintSlug
		});
	}

	initCheckoutModal() {
		new CheckoutModal();
	}
}